import { useMemo } from 'react'

import { useAuth } from './useAuth'
import { Permission } from '../types'

export default function useCheckPermission(permissions: Permission[]) {
  const { hasPermission } = useAuth()

  return useMemo(() => {
    return permissions.every(permission => hasPermission(permission))
  }, [permissions, hasPermission])
}
